import { useCheckLoadedAndShow } from '../hooks/useCheckLoadedAndShow';
export var VA_BENEFITS_FINAL_DEST_REGEXP = /https:\/\/www\.va\.gov\/my-va\/\?postLogin=true/;
export function useVaBenefits() {
    useCheckLoadedAndShow();
}
